<template>
  <h1>Om KL's valgberegner</h1>
  <p>
    KL’s valgberegner kan bruges til at beregne fordelingen af mandater ved
    valg, simulering af valgforbund og andre situationer, hvor man skal bruge
    den D'Hondtske metode.
  </p>
  <p>
    Du kan bruge KL’s valgberegner på to måder. Du kan dels hente stemmetal for
    enkeltkommuner fra Kommunalvalget 2021 og lave beregninger med afsæt i
    disse. Du kan også bruge KL’s valgberegner alene med egne data. De kommunale
    valgresultater fra Kommunalvalget 2021, som kan indlæses i KL’s valgberegner
    bygger på data fra KMD Valg.
  </p>
  <p>
    KL’s valgberegner er baseret på den D’Hondtske metode. Det er den
    fordelingsmetode, der bruges i Danmark, ved fx fordeling af mandater i
    forbindelse med kommunalvalg og ved konstitueringer i kommunalbestyrelser.
  </p>
  <p>
    KL påtager sig ikke ansvar for beregninger foretaget med KL’s valgberegner.
  </p>
</template>

<script>
export default {
  components: {},
};
</script>
